import type { GenieKnowledgeEntry } from '../../types';

export const inflammatoryMyopathy: GenieKnowledgeEntry = {
  id: 'inflammatory_myopathy',
  name: 'Miopatía Inflamatoria',
  category: 'miopatico',
  conversation: {
    headline:
      'Polimiositis/dermatomiositis: debilidad proximal + CK elevada. EMG con CRD y fibrilaciones activas.',
    edxHighlights: [
      'PAUMs miopáticos (pequeños, cortos) + reclutamiento precoz',
      'Actividad espontánea aumentada: fibrilaciones, CRD, descargas complejas repetitivas',
      'Patrón proximal: deltoides, cuádriceps, iliopsoas',
      'NCS normal — confirma origen muscular',
    ],
    pearls: [
      'CRD sin miopatía inflamatoria puede verse en UNM — correlacionar con CK y clínica.',
      'Dermatomiositis puede tener NCS normal y EMG leve — no descartar por EMG sutil.',
    ],
    nextSteps: [
      'CK, aldolasa, anti-Jo-1, anti-Mi-2, anti-SRP',
      'RM muscular o biopsia si diagnóstico incierto',
    ],
  },
  orientationHints: {
    temporalFit: ['subacute', 'chronic'],
    whenToSuspect: 'Debilidad proximal progresiva + CK elevada ± rash (dermatomiositis)',
  },
};
